
export interface ProductSnapshot {
    name: string;
    headImageUrl: string;
    description: string;
}

export enum SpecificationType {
    TRIAL = 0,
    STANDARD = 1
}

export enum OrderStatus {
    PENDING_PAYMENT = 0,         // 待支付
    PAID_PENDING_SERVICE = 1,    // 待开启服务
    SERVICE_IN_PROGRESS = 2,     // 服务进行中
    PENDING_ACCEPTANCE = 3,      // 待验收
    COMPLETED = 4,               // 已完成
    CANCELLED = 5                // 已取消
}

export interface Order {
    orderId: string;
    productId: string;
    productSnapshot: ProductSnapshot;
    specificationType: SpecificationType;
    price: number;
    quantity: number;
    status: OrderStatus;
    orderTime: Date;
    paymentTime?: Date | null;
    startTime?: Date | null;
    deliveryTime?: Date | null;
    agreeTime?: Date | null;
    buyerId: string;//具体信息请调用BuyerApi中的接口
    sellerId: string;//一定是当前登录的用户
    pdfContractList?: string[];
    quickContractList?: string[];
    demandDescription?: string;
}
  

/** 0-未签字PDF（需APP签署），1-已签字PDF（线下凭证） */
export enum PdfSignMode {
    UNSIGNED = 0,
    PRE_SIGNED = 1,
}

export interface PdfContract {
    contractId: string;
    contractName: string;
    contractNo: string;
    pdfUrl: string;
    signTime?: string | null;
    signerId: string;
    signerName: string;
    posterId: string;
    posterName: string;
    postTime: string;
    posterSignTime?: string | null;
    status?: number;
    pdfSignMode?: PdfSignMode | number;
}

export interface QuickContract {
    contractId: string;
    contractName: string;
    contractNo: string;
    posterId: string;
    posterName: string;
    posterSignTime: string;
    posterSignUrl: string;
    signerId: string;
    signerName: string;
    signerSignTime: string;
    signerSignUrl: string;
    postTime: string;
    content: string;
    status: number;
}